import React, { useMemo } from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import {
    surveyOptions,
    optionBtn,
    optionBtnActive as optionBtnActiveClass,
    optionBtnIcon,
    optionIcon,
    optionLabel,
    surveyOptionsGrid,
} from "./survey-answer-question-card.module.scss";

export interface ISurveyAnswerOptionsProps {
    question: ISurveyQuestion;
    value: string | number | Array<string | number> | null;
    onChange: (value: string | number | Array<string | number>) => void;
    isMulti: boolean;
    onSave?: (value: string | number | Array<string | number>, shouldClose?: boolean) => void;
}

const SurveyAnswerOptions: React.FC<ISurveyAnswerOptionsProps> = ({
    question,
    value,
    onChange,
    isMulti,
    onSave,
}) => {
    const { options } = question;

    const hasImages = useMemo(() => {
        return options && options.some((option) => option.imgUrl);
    }, [options]);

    const normalizeValue = (val: string | number): string | number => {
        // Konwertuj string na number jeśli to możliwe, dla spójności porównań
        if (typeof val === "string" && !isNaN(Number(val)) && val.trim() !== "") {
            return Number(val);
        }
        return val;
    };

    const isOptionSelected = (optionId: number | string): boolean => {
        if (!value) return false;
        
        const normalizedOptionId = normalizeValue(optionId);
        
        if (Array.isArray(value)) {
            return value.some((v) => {
                if (typeof v === "string" || typeof v === "number") {
                    return normalizeValue(v) === normalizedOptionId;
                }
                return false;
            });
        }
        
        if (typeof value === "string" || typeof value === "number") {
            return normalizeValue(value) === normalizedOptionId;
        }
        
        return false;
    };

    const handleOptionClick = (optionId: number | string) => {
        const normalizedOptionId = normalizeValue(optionId);
        
        if (isMulti) {
            const currentValues = Array.isArray(value) ? value.map(v => normalizeValue(v)) : [];
            const isSelected = currentValues.some(v => v === normalizedOptionId);
            
            let newValue: Array<string | number>;
            if (isSelected) {
                newValue = currentValues.filter((v) => v !== normalizedOptionId);
            } else {
                newValue = [...currentValues, normalizedOptionId];
            }
            onChange(newValue);
            // if (onSave) {
            //     onSave(newValue, false); // false = nie zamykaj pytania
            // }
        } else {
            onChange(normalizedOptionId);
            // if (onSave) {
            //     onSave(normalizedOptionId, false); // false = nie zamykaj pytania
            // }
        }
    };

    return (
        <div className={`${surveyOptions} ${hasImages ? surveyOptionsGrid : ""}`}>
            {options &&
                options.map((option) => {
                    const optionId = (option.id ?? option.value) as string | number;
                    if (optionId === undefined) return null;
                    
                    const isActive = isOptionSelected(optionId);
                    const hasImage = !!option.imgUrl;

                    if (hasImage) {
                        return (
                            <button
                                key={optionId}
                                type="button"
                                className={`${optionBtn} ${optionBtnIcon} ${isActive ? optionBtnActiveClass : ""}`}
                                onClick={() => handleOptionClick(optionId)}
                                data-value={option.label}
                            >
                                <span className={optionIcon} aria-hidden="true">
                                    <img src={option.imgUrl || ""} alt="" />
                                </span>
                                <span className={optionLabel}>{option.label}</span>
                            </button>
                        );
                    }

                    return (
                        <button
                            key={optionId}
                            type="button"
                            className={`${optionBtn} ${isActive ? optionBtnActiveClass : ""}`}
                            onClick={() => handleOptionClick(optionId)}
                            data-value={option.label}
                        >
                            {option.label}
                        </button>
                    );
                })}
        </div>
    );
};

export default SurveyAnswerOptions;
